import React from "react";

const DiscoverContentRatings = ({
  style = {},
  width = 19,
  height = 19,
  className = "",
  color = "#017CC1",
  viewBox = "0 0 19 19",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      className={className}
      style={style}
      {...rest}>
      <g fill="none" fillRule="evenodd">
        <path
          fill={color}
          d="M19 0h-3v19h3zM15 3h-3v16h3zM11 9H8v10h3zM7 10H4v9h3zM3 12H0v7h3z"
        />
        <path
          d="M3.138 6.918h.497l.176-.17a4.088 4.088 0 11.44.44l-.17.177v.497L.938 11 0 10.063l3.138-3.145zm3.774 0a2.826 2.826 0 002.83-2.83 2.826 2.826 0 00-2.83-2.83 2.826 2.826 0 00-2.83 2.83 2.826 2.826 0 002.83 2.83z"
          fill={color}
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
};

export default DiscoverContentRatings;
